import { Icon } from "@iconify/react";
import React, { useEffect, useState } from "react";

import http from "../../../services/httpServices";
import { motion, AnimatePresence } from "framer-motion";

import Container from "../../../components/ui/Container";
import LoadingIcon from "../../../components/ui/LoadingIcon";
import SideTitle from "../../../components/ui/SideTitle";
import CourseCard from "../../../components/ui/CourseCard";
import auth from "../../../services/authServices";
import Button from "../../../components/ui/Button";
import CenterIcon from "../../../components/ui/CenterIcon";

const Categorie = ({
    titleFirst = false,
    titleLast,
    api = ``,
    className = "",
    grid = "normal",
    noCoursesPlaceholder = `سيتم إضافه ${
        titleFirst ? `${titleFirst} ${titleLast}` : "الكورسات"
    } قريبا`,
    coursesList = false,
    isPrepaid = false,
    layout = "default", // New: layout type
    onPrepaidClick = null,
    isToHide = true,
    isToAssignCourses = null,
    onAssignCourseClick = false,
    sortColumn = null,
    sortDir = "asc",
}) => {
    const [courses, setCourses] = useState([]);
    const [showCourses, setShowCourses] = useState(!isToHide);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [coursesPerSlide, setCoursesPerSlide] = useState(1);
    const [visibleCourses, setVisibleCourses] = useState(3); // Initially show 3 courses
    const [showAll, setShowAll] = useState(false); // Track if all courses are visible

    // const handleToggleCourses = () => {
    //     if (showAll) {
    //         setVisibleCourses(3); // Reset to initial state
    //         setShowAll(false);
    //     } else {
    //         setVisibleCourses(courses.length); // Show all courses
    //         setShowAll(true);
    //     }
    // };

    // Update number of courses per slide based on screen size
    const updateSlides = () => {
        if (window.innerWidth >= 1024) {
            setCoursesPerSlide(3); // lg: 3 courses
        } else if (window.innerWidth >= 768) {
            setCoursesPerSlide(2); // md: 2 courses
        } else {
            setCoursesPerSlide(1); // sm: 1 course
        }
    };

    useEffect(() => {
        updateSlides();
        window.addEventListener("resize", updateSlides);
        return () => window.removeEventListener("resize", updateSlides);
    }, []);

    useEffect(() => {
        if (layout === "carousel" && courses.length > 0) {
            const interval = setInterval(() => {
                setCurrentIndex((prevIndex) => (prevIndex + coursesPerSlide) % courses.length);
            }, 7000);
            return () => clearInterval(interval);
        }
    }, [courses, layout, coursesPerSlide]);

    if (!className.includes("space-x")) {
        if (grid === "normal") {
            className += ` grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-10`;
        } else {
            className += ` grid-cols-1 lg:grid-cols-2 gap-5`;
        }
    }

    const [placeholder, setPlaceholder] = useState(
        <div className="font-h2 col-span-1 md:col-span-2 lg:col-span-3 py-20">
            <span className="flex-center-both space-x-3 space-x-reverse">
                <LoadingIcon className={"font-h1 text-teal-600 dark:text-teal-400"} />
                <span>يتم الآن تحميل الكورسات</span>
            </span>
        </div>
    );

    const getCourses = async (getAll = false) => {
        try {
            const token = auth.getToken();
            const config = auth.getAuthConfig(token);
            const { data } = await http.get(api, config);

            setCourses([]);
            setCourses(data);
            setPlaceholder(
                <div className="font-h2 col-span-1 md:col-span-2 lg:col-span-3 py-20">
                    <span className="flex-center-both space-x-3 space-x-reverse">
                        <span className="font-h1 flex-center-both text-mint-600 dark:text-mint-400">
                            <Icon icon="carbon:data-error" />
                        </span>
                        <span>{noCoursesPlaceholder}</span>
                    </span>
                </div>
            );
        } catch (error) {
            setPlaceholder(
                <div className="font-h2 col-span-1 md:col-span-2 lg:col-span-3 py-20">
                    <span className="flex-center-both space-x-3 space-x-reverse">
                        <span className="font-h1 flex-center-both text-rose-600 dark:text-rose-400">
                            <Icon icon="carbon:data-error" />
                        </span>
                        <span>حدث خطأ اثناء التحميل</span>
                    </span>
                </div>
            );
        }
    };

    useEffect(() => {
        if (coursesList) {
            setCourses(coursesList);
            setPlaceholder(
                <div className="font-h2 col-span-1 md:col-span-2 lg:col-span-3 py-20">
                    <span className="flex-center-both space-x-3 space-x-reverse">
                        <span className="font-h1 flex-center-both text-rose-600 dark:text-rose-400">
                            <Icon icon="carbon:data-error" />
                        </span>
                        <span>{noCoursesPlaceholder}</span>
                    </span>
                </div>
            );
        } else {
            if (api) {
                getCourses();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [coursesList, api]);
    return (
        <Container>
            {titleFirst ? <SideTitle first={titleFirst} last={titleLast} /> : ""}

            {showCourses && layout === "default" ? (
                <div
                    className={`g-teal-400 smooth clr-text-primary drk:bg-teal-800 bg-opacity-50 dark:bg-opacity-50 grid ${className}`}
                >
                    {courses.length < 1 && placeholder}
                    {courses.length > 0 &&
                        courses.map((course) => {
                            return (
                                <CourseCard
                                    key={course.id}
                                    {...course}
                                    isToAssignCourses={isToAssignCourses}
                                    onAssignCourseClick={onAssignCourseClick}
                                    isPrepaid={isPrepaid}
                                    onPrepaidClick={onPrepaidClick}
                                />
                            );
                        })}
                </div>
            ) : layout === "carousel" ? (
                <div className="relative w-full py-10 max-w-7xl mx-auto overflow-hidden">
                    <AnimatePresence mode="wait">
                        {courses.length > 0 && (
                            <motion.div
                                key={currentIndex}
                                initial={{ opacity: 0, x: 100 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: -100 }}
                                transition={{ duration: 0.6 }}
                                className="flex space-x-6 space-x-reverse justify-center items-center"
                            >
                                {courses
                                    .slice(currentIndex, currentIndex + coursesPerSlide)
                                    .map((course, index) => (
                                        <div key={index} className="flex-1 max-w-[450px]">
                                            <CourseCard {...course} />
                                        </div>
                                    ))}
                            </motion.div>
                        )}
                    </AnimatePresence>

                    {/* Indicators */}
                    <div className="flex justify-center space-x-reverse space-x-2 mt-6">
                        {Array.from({ length: Math.ceil(courses.length / coursesPerSlide) }).map(
                            (_, index) => (
                                <div
                                    key={index}
                                    className={`w-3 h-3 rounded-full cursor-pointer transition-all ${
                                        Math.floor(currentIndex / coursesPerSlide) === index
                                            ? "bg-teal-600"
                                            : "bg-gray-300"
                                    }`}
                                    onClick={() => setCurrentIndex(index * coursesPerSlide)}
                                ></div>
                            )
                        )}
                    </div>
                </div>
            ) : (
                <div className="flex-center-both">
                    <div
                        className="bg-slate-500 border-slate-500 clr-text-primary smooth px-20 py-t-2 pb-2 font-h1 bg-opacity-5 rounded-md border-2 cursor-pointer"
                        onClick={() => setShowCourses(!showCourses)}
                    >
                        ....
                    </div>
                </div>
            )}
        </Container>
    );
};

export default Categorie;
